export const UPLOAD_FILE_MAX_BYTES = 5242880 // 5*1024*1024
export const LITHUANIAN_UPLOAD_FILE_MAX_BYTES = 10485760 // 10*1024*1024
export const MAX_FILE_NAME_LENGTH = 70
export const ESTONIAN_MAX_FILE_NAME_LENGTH = 50

const ESTONIAN_MIME_TYPES = [
  'application/vnd.openxmlformats-officedocument.wordprocessingml.document', //  docx, doc
  'image/jpeg', //  jpg jpeg
  'application/vnd.etsi.asic-e+zip', //  asice, bdoc, ddoc, sce
  'image/gif', //  gif
  'application/rtf', //  rtf
  'application/x-rtf', //  rtf
  'text/richtext', //  rtf
  'text/csv', //  csv
  'image/png', //  png
  'image/tiff', //  tif, tiff
  'image/x-tiff', //  png
  'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet', //  xlsx
  'text/plain', //  txt
  'application/pdf', //  pdf
  'application/xml', //  xml
  'text/xml', //  xml
  'application/msword', //  doc
  'application/vnd.ms-excel', //  xls
  'application/x-excel', //  xls
  'application/x-msexcel', //  xls
  'application/vnd.oasis.opendocument.text', //  odt
  'application/vnd.oasis.opendocument.spreadsheet', //  ods
]

const LATVIAN_EXTENSIONS = [
  '.pdf', '.jpeg', '.jpg', '.tiff', '.tif', '.png', '.zip',
]

const LITHUANIAN_EXTENSIONS = [
  '.pdf', '.jpeg', '.png', '.jpg',
]

export interface FileTypeMeta {
  fileName: string | null
  mimeType: string
}

export interface CountryFilePolicy {
  maxBytes: number
  maxFileNameLength: number
  allowedExtensions: string[] | null
  isAcceptedFileType: (meta: FileTypeMeta) => boolean
  invalidFileTypeMessage: { key: string; options?: Record<string, unknown> }
}

const INVALID_FILE_TYPE_MESSAGE = { key: 'excel.invalidMimeType' }

const hasAllowedExtension = (allowedExtensions: string[]) => ({ fileName }: FileTypeMeta) => (
  fileName !== null && allowedExtensions.some((extension) => fileName.toLowerCase().endsWith(extension))
)

const ACCEPTS_ANY_FILE_TYPE = () => true

export function getCountryFilePolicy(country: string | undefined): CountryFilePolicy {
  switch (country) {
    case 'EE':
      return {
        maxBytes: UPLOAD_FILE_MAX_BYTES,
        maxFileNameLength: ESTONIAN_MAX_FILE_NAME_LENGTH,
        allowedExtensions: null,
        isAcceptedFileType: ({ mimeType }) => ESTONIAN_MIME_TYPES.includes(mimeType),
        invalidFileTypeMessage: INVALID_FILE_TYPE_MESSAGE,
      }
    case 'LV':
      return {
        maxBytes: UPLOAD_FILE_MAX_BYTES,
        maxFileNameLength: MAX_FILE_NAME_LENGTH,
        allowedExtensions: LATVIAN_EXTENSIONS,
        isAcceptedFileType: hasAllowedExtension(LATVIAN_EXTENSIONS),
        invalidFileTypeMessage: { key: 'excel.invalidMimeType', options: { context: 'allowed', 0: LATVIAN_EXTENSIONS } },
      }
    case 'LT':
      return {
        maxBytes: LITHUANIAN_UPLOAD_FILE_MAX_BYTES,
        maxFileNameLength: MAX_FILE_NAME_LENGTH,
        allowedExtensions: LITHUANIAN_EXTENSIONS,
        isAcceptedFileType: hasAllowedExtension(LITHUANIAN_EXTENSIONS),
        invalidFileTypeMessage: { key: 'excel.invalidMimeType', options: { context: 'allowed', 0: LITHUANIAN_EXTENSIONS } },
      }
    default:
      return {
        maxBytes: UPLOAD_FILE_MAX_BYTES,
        maxFileNameLength: MAX_FILE_NAME_LENGTH,
        allowedExtensions: null,
        isAcceptedFileType: ACCEPTS_ANY_FILE_TYPE,
        invalidFileTypeMessage: INVALID_FILE_TYPE_MESSAGE,
      }
  }
}
